<template>
  <base-table-wrapper>
    <template #top-buttons>
      <router-link tag="button" :to="{ name: 'EXSBDocumentCreate' }" class="float-right mb-1 btn btn-sm btn-primary">{{ $t('buttons.create') }}</router-link>
    </template>
    <template #filtering>
      <div class="text-right">
        <b-button class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.userdata_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
      </div>
      <div>
        <b-collapse id="userdata_search_collapse" class="mt-2">
          <DocumentFiltering @getPage="getPage($event)"></DocumentFiltering>
        </b-collapse>
      </div>
    </template>
    <template #body>
      <Loader v-if="isLoading"></Loader>
      <div v-else-if="!isLoading && items.length < 1">
        {{ $t('views.exsbdocument.list.noDocuments') }}
      </div>
      <table v-else class="table table-sm table-responsive-md table-striped table-hover">
        <thead>
        <tr>
          <th>{{$t('views.exsbdocument.list.documentType')}}</th>
          <th>{{$t('views.exsbinvoices.show.title')}}</th>
          <th>{{$t('views.excmtask.list.table.task')}}</th>
          <th>{{$t('views.exsbdocument.list.number')}}</th>
          <th>{{$t('views.exsbdocument.list.dateOfIssue')}}</th>
          <th style="width: 5%" />
        </tr>
        </thead>
        <tbody>
        <tr
          v-for="item in items"
          :key="item['@id']">
          <td>
              {{ item['documentType'].name }}
          </td>
          <td v-if="item.idInvoice">
            <router-link v-if="ableToViewInvoices" :to="{ name: 'EXSBInvoiceShow', params: { id: item.idInvoice['@id'] } }">
              {{ item.idInvoice.number }}
            </router-link>
            <span v-else> {{ item.idInvoice.number }} </span>
          </td>
          <td v-else></td>
          <td v-if="item.task">
            <router-link v-if="ableToViewTask" :to="{ name: 'EXCMTaskShow', params: { id: item.task['@id'] } }">
              {{ item.task.idTaskType.title }}
            </router-link>
            <span v-else> {{ item.task.idTaskType.title }} </span>
          </td>
          <td v-else></td>
          <td>
              {{ item['number'] }}
          </td>
          <td>
              {{ item['dateOfIssue'] }}
          </td>
          <td>
            <router-link tag="button" :to="{name: 'EXSBDocumentShow', params: { id: item['@id'] }}" class="btn btn-link fa fa-search fa-lg" />
          </td>
        </tr>
        </tbody>
      </table>
      <div v-if="view">
        <pagination
          :view="view"
          @getPage="getPage($event)"
        ></pagination>
      </div>
    </template>
  </base-table-wrapper>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
import { checkPagePermission, checkPermission } from '@/utils/checkRoles.js'
import Loader from '../../../Layout/Loader'
import Pagination from '../../../Layout/Pagination'
import BaseTableWrapper from '@/components/BaseComponents/BaseTableWrapper'
import DocumentFiltering from '@/components/Dashboard/Views/BusinessBundle/exsbdocument/components/DocumentFiltering'

export default {
  components: {
    Loader,
    Pagination,
    BaseTableWrapper,
    DocumentFiltering
  },

  computed: {
    ...mapGetters({
      deletedItem: 'exsbdocument/del/deleted',
      error: 'exsbdocument/list/error',
      items: 'exsbdocument/list/items',
      isLoading: 'exsbdocument/list/isLoading',
      view: 'exsbdocument/list/view'
    }),
    ableToViewInvoices () {
      return checkPermission('finances', 'EXSBInvoiceShow')
    },
    ableToViewTask () {
      return checkPermission('tasks', 'EXCMTaskShow')
    }
  },

  beforeCreate () {
    checkPagePermission('warehouses', 'EXSBDocumentList')
  },

  created () {
    this.getPage()
    this.channelBusinessDocuments = this.$store.state.Pusher.subscribe('e_x_s_b_documents')
    this.channelBusinessDocuments.bind('e_x_s_b_documents', data => {
      this.getPage()
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('e_x_s_b_documents')
  },

  watch: {
    items: function (listItems) {
      for (let i in listItems) {
        listItems[i]['dateOfIssue'] = moment(listItems[i]['dateOfIssue']).format('YYYY-MM-DD')
      }
    }
  },

  methods: mapActions({
    getPage: 'exsbdocument/list/default'
  })
}
</script>
